import type { EntityBase } from '@opengov/psp-contract';
import type { Entity } from '../types';

/**
 * Extract base entity fields from a full entity object.
 * This reduces memory usage and improves performance when rendering large lists.
 *
 * @param entity - The full entity object
 * @returns A base entity object with only essential fields
 */
export function extractBaseEntity(entity: Entity): EntityBase {
  return {
    id: entity.id,
    friendlyId: entity.friendlyId,
    entityId: entity.entityId,
    name: entity.name,
    displayName: entity.displayName,
    federatedServiceIds: entity.federatedServiceIds,
    timezone: entity.timezone ?? null,
  };
}
